<template>
  <div class="word-list11">
    <div class="head" v-for="item in dataList" :key="item.id">
      <img class="img" :src="item.image" alt="" />
      <div class="title">
        {{ item.title }}
      </div>
      <div class="btn" @click="toDetail(item)">查看详情 ></div>
    </div>
  </div>
</template>

<script>
import pageMain_mx from "../../mixins/pageMain_mx";

export default {
  data() {
    return {
      query: this.$route.query,
      dataInfo: {},
      dataList: []
    };
  },
  mixins: [pageMain_mx],
  components: {},
  mounted() {},
  methods: {
    async init() {
      // const dataInfo = await this.getMenuInfo(this.query.id);
      const data = await this.getMenuList({
        pageNum: 1,
        pageSize: 15,
        menuId: this.query.id
      });
      this.dataList = data;
      console.log(this.dataList, "dataInfo");
    },
    toDetail(item) {
      window.open(item.url);
    }
  }
};
</script>
<style lang="less">
.word-list11 {
  .head {
    position: relative;
    height: 710px;
    width: 1920px;
    box-sizing: border-box;
    .img {
      position: absolute;
      left: 0;
      top: 0;
      height: 710px;
      width: 1920px;
    }
    .title {
      position: absolute;
      left: 360px;
      top: 338px;
      content: "";
      font-size: 48px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
    }
    .btn {
      position: absolute;
      left: 360px;
      top: 455px;
      content: "";
      display: flex;
      align-items: center;
      justify-content: center;
      width: 162px;
      height: 54px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      border: 2px solid #fff;
      cursor: pointer;
    }
  }
}
</style>
